<template>
  <div class="column ">
    <q-select
      outlined
      dense
      v-model="selectedValue"
      map-options
      emit-value
      hide-dropdown-icon
      :options="filteredOptions"
      option-value="id"
      option-label="label"
      bg-color="white"
      :options-dense="true"
      class="col-auto myFieldSelect"
      :disable="disabled"
    >
      <template #append>
        <div
          v-if="!loading"
          class="row items-center justify-center"
        >
          <ArrowDownIcon class="col" />
        </div>

        <q-spinner
          v-if="loading"
          color="primary"
          size="xs"
        />
      </template>
    </q-select>
  </div>
</template>

<script>
import ArrowDownIcon from '@/assets/icons/arrowDown.svg'
import { mapGetters } from 'vuex'
export default {
  components: {
    ArrowDownIcon
  },

  props: {

    value: {}

  },

  data () {
    return {
      selectedValue: this.value,
      filteredOptions: this.list,
      disabled: false,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      sessionMembership: 'agentModule/sessionMembership'
    })
  },

  mounted () {
    const queueList = this.sessionMembership

    if (!queueList.length) {
      this.loading = true
      return
    }

    if (queueList) {
      this.filteredOptions = queueList.filter((item) => !item.queueId.startsWith('iqda')).map((item) => {
        return { id: item.queueId, label: item.queueName }
      })
    }
    this.loading = false
  },

  watch: {
    selectedValue (selectedValue) {
      if (selectedValue === this.value) return
      this.$router.push({ name: 'ROUTE_PREVIEW_DETAILS', params: { queueId: selectedValue } })
      this.$emit('input', selectedValue)
    },

    value (value) {
      if (value === this.selectedValue) return
      this.selectedValue = value
    },

    '$route.name': {
      handler (routeName) {
        if (routeName === 'ROUTE_PREVIEW_DETAILS') {
          this.disabled = false
        }

        if (routeName === 'ROUTE_PREVIEW_CURRENT') {
          this.disabled = true
        }
      },

      immediate: true

    },

    sessionMembership: {
      handler (queues) {
        this.filteredOptions = queues.filter((item) => !item.queueId.startsWith('iqda')).map((item) => {
          return { id: item.queueId, label: item.queueName }
        })
        this.loading = false
      }

    },
    deep: true,
    immediate: true
  }
}

</script>

<style lang="sass">
.myFieldSelect
  .q-field__control
    min-height: 20px
    min-width: 250px

    .q-field__control-container
      font-size: 14px

    &:hover
      &:before
        border: 1px solid #486e8e !important
        transition: none

    &:after
      border-width: 1px !important

</style>
